import { TypeCheck } from '@toptoon/utils';
import Cookies from 'js-cookie';
import _ from 'lodash';
import moment from 'moment';
import { version } from '../../package.json';
import { v4 as uuid } from 'uuid';
import { UserLoginService } from '@persistStores/UserLogin';
import { UserSessionService } from '@persistStores/UserSession';
import { getSSRCookie } from './Utils';
// 선물함 대상값
export type GiftTarget = {
  code?: string;
  loginId: string;
} | null;

// 3코인 기준 유저그룹 생성
export enum UserTypeByCoin {
  MembershipRequiredUnder3Coin = 'MembershipRequired', // 3 코인 이하
  MembershipActivateMore3Coin = 'MembershipActivate', // 3 코인 이상
}

const uuidv4 = () => {
  return uuid();
};

export interface UserSessionHeaderType {
  version: string;
  apiKey: string;
  baseUrl: string;
  uuid: string;
  ua: string;
  partnerCode: string;
  language: string;
  userId: string;
  packageName?: string;
  'x-origin': string;
}

// const language = 'en';
const language = 'ja';

// TODO: low code split
export default class UserDefault {
  static USERINFO: string = 'userinfo_key';

  static MAXDAYS: number = 30;

  static GIFT_TARGET_KEY: string = 'giftTargetUser3';

  static GIfT_TARGET_DAYS: number = 1;

  // 파트너 코드 비성인용 (구글 광고용)
  static PARTNER_17_CODE: string = 'p_code17';

  // 파트너 코드 성인용
  static PARTNER_CODE: string = 'p_code';

  // 파트너 코드 성인 강제 비노출 조건
  static PARTNER_CODE_FORCE_DISABLE_MATURE: string =
    'p_code_force_disable_mature';

  static REMATE_ORIGIN: string = 'remake_origin';

  // 사전 성인증 키
  static ALREADY_MATURE: string = 'already_mature';

  // 임시 ID
  static TEMPARARY_TOKEN: string = 'temparary_token';

  // 로그인 카운트 수집용 cookie
  static LOGIN_COUNT_CHECK: string = 'login_count_check';

  // locale 확인용
  static KEY_USER_LOCALE = 'user_locale';

  static US: string = 'us'; // 미국

  static SG: string = 'sg'; // 싱가포르

  static MY: string = 'my'; // 말레이시아

  // 5일 기한 체크 레어어
  static FIVE_DAY_CHECK: string = '5_d_check';

  // 20코인 미만 결제자 확인
  static USER_20COIN_UNDER: string = 'u20c_user';

  static USER_SMS_AUTH: string = 'user_sms_auth';

  // app package 구분 값
  static APP_PACKAGE_NAME: string = 'app_package_name';

  static APP_FCM_TOKEN: string = 'app_fcm_token';

  static APP_VERSION: string = 'app_version';

  // 앱 소셜 로그인시 현재 location 정보 저장
  static APP_CURRNET_LOCATION: string = 'current_location';

  // 다운로드 중복 체크 처리
  static APP_DOWNLOAD_CHECK: string = 'app_download_check';

  static EPISODE_ADD_HOME_LAYER_CHECK: string = 'episode_add_home_layer';

  // TODO: 이탈 방지 무료이용권
  static BLOCKED_WHEN_OUT_OF_SECRET_CLASS: string =
    'blocked_when_out_of_secret_class';

  // 이탈 방지 작품 리스트
  static BLOCKED_COMICS_CODE: string = 'blocked_comics_code';

  static BlockComicList = {
    setter: (items: any[]) => {
      const list: string = JSON.stringify(items);
      localStorage.setItem(UserDefault.BLOCKED_COMICS_CODE, list);
    },
    getter: () => {
      const listString: string | null = localStorage.getItem(
        UserDefault.BLOCKED_COMICS_CODE,
      );

      if (listString) {
        return JSON.parse(listString);
      }
      return [];
    },
  };

  /* -------------------------------------------------------------------------- */

  // 앱 다운로드 체크 중복 방지용 settter
  static setDownloadCheck() {
    localStorage.setItem(this.APP_DOWNLOAD_CHECK, 'downloaded');
  }

  // 앱 다운로드 체크 중복 방지용 getter
  static getDownloadCheck() {
    return localStorage.getItem(this.APP_DOWNLOAD_CHECK) ?? null;
  }

  static setBuckets(refOrderIds: any) {
    Cookies.set('buckets', JSON.stringify(refOrderIds), { expires: 1 });
  }

  static getBuckets() {
    return Cookies.get('buckets') ?? null;
  }

  static removeBuckets() {
    Cookies.remove('buckets');
  }

  /* -------------------------------------------------------------------------- */
  // ANCHOR: => 멤버쉽 조건 판별
  /* -------------------------------------------------------------------------- */

  static isMembershipRequired(
    paymentCount: number,
    co: { coin: number; bonusCoin: number },
    userSubscribe: null | string,
  ): boolean {
    // if (userSubscribe === MembershipCode.NOT_SET) {
    //   return true;
    // }

    // if (co.coin + co.bonusCoin === 0 && paymentCount <= 2) {
    //   return true;
    // }

    return false;
  }

  /**
   * 메인 레이어 노출 조건 제어용으로 추가됨
   */
  static isMembershipRequiredForLayer(
    paymentCount: number,
    co: { coin: number; bonusCoin: number },
    userSubscribe: null | string,
  ): boolean {
    // if (userSubscribe === MembershipCode.NOT_SET) {
    //   return true;
    // }

    // if (co.coin + co.bonusCoin === 0 && paymentCount <= 2) {
    //   return true;
    // }

    return false;
  }

  /* -------------------------------------------------------------------------- */
  // TODO: => 임시
  /* -------------------------------------------------------------------------- */
  static getUserSession(): UserSessionHeaderType {
    const localStorage: any = UserDefault.getLocalStorage();
    const uuid = localStorage ? this.getUdid(localStorage) : '';
    const ua = 'web';
    const partnerCode = `${Cookies.get('partner_code') ?? ''}`;
    const userId = UserSessionService.getUserInfoUserId();
    const origin =
      process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'
        ? 'toptoon.jp'
        : 'staging.toptoon.jp';

    const packageVersion = version;
    return {
      version: packageVersion,
      apiKey: `${process.env.NEXT_PUBLIC_API_KEY}`,
      baseUrl: `${process.env.NEXT_PUBLIC_BASE_URL}`,
      uuid: uuid ? uuid : '',
      ua,
      partnerCode,
      language,
      userId,
      'x-origin': origin,
    };
  }

  static getUserSessionHeaderSSR(context: any): UserSessionHeaderType {
    const info = UserSessionService.getUserInfoSSR(context);
    const packageVersion = version;
    const uuid = getSSRCookie(context, 'udid');
    const partnerCode = getSSRCookie(context, 'partner_code');

    const origin =
      process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'
        ? 'toptoon.jp'
        : 'staging.toptoon.jp';

    return {
      version: packageVersion,
      'x-origin': origin,
      apiKey: `${process.env.NEXT_PUBLIC_API_KEY}`,
      baseUrl: `${process.env.NEXT_PUBLIC_BASE_URL}`,
      uuid: uuid ? uuid : '',
      ua: 'web',
      partnerCode: partnerCode ? partnerCode : '',
      language,
      userId: UserSessionService.getUserInfoSSRUserId(context),
    };
  }

  // static getTestSession() {
  //   // cookie 활용 임시
  //   const uuid = `${Cookies.get('udid') ?? ''}`;
  //   const ua = 'web';
  //   const partnerCode = `${Cookies.get('partner_code') ?? ''}`;
  //   const userId = `${UserLoginService.userInfo.get('userId') ?? ''}`;

  //   const packageVersion = version;
  //   let result: any = {
  //     version: packageVersion,
  //     apiKey: `${process.env.NEXT_PUBLIC_API_KEY}`,
  //     baseUrl: `${process.env.NEXT_PUBLIC_BASE_URL}`,
  //     uuid,
  //     ua,
  //     partnerCode,
  //     language: 'ja',
  //     userId,
  //   };
  //   return result;
  // }

  static getApiDefaultHeaders(localStorage: Storage) {
    const uuid = this.getUdid(localStorage);
    const ua = this.getPackageName(localStorage);
    const partnerCode = this.getPartnerData(localStorage).code;
    const userId = this.HeaderUserId.getter(localStorage);

    const packageVersion = version;
    let result: any = {
      version: packageVersion,
      apiKey: `${process.env.NEXT_PUBLIC_API_KEY}`,
      baseUrl: `${process.env.NEXT_PUBLIC_BASE_URL}`,
      uuid,
      ua,
      partnerCode,
      language,
      userId,
    };

    return result;
  }

  /* -------------------------------------------------------------------------- */
  // ANCHOR: => event 영역
  /* -------------------------------------------------------------------------- */
  // ANCHOR: 결제 이벤트 sale 뱃지, 이벤트 , 충전소, 회차리스트 배
  /**
   * @deprecated
   */
  static setHalloweenEvent(eventValue: boolean) {
    Cookies.set('HalloweenEvent', eventValue.toString());
  }

  /**
   * @deprecated
   * @returns
   */
  static isHalloweenEvent() {
    // return Cookies.get('HalloweenEvent') === 'true';
    // 211104 수정됨
    return false;
  }

  // ANCHOR: 로고 이벤트
  static setHalloweenLogoEvent(eventValue: boolean) {
    Cookies.set('HalloweenLogoEvent', eventValue.toString());
  }

  /**
   * @deprecated
   * @returns
   */
  static isHalloweenLogoEvent() {
    // return Cookies.get('HalloweenLogoEvent') === 'true';
    // 211104 수정됨
    return false;
  }

  /**
   * @deprecated
   * 블랙 프라이데이 이벤트
   * @returns
   */
  static isBlackFridayEvent() {
    const NOW = moment().utc();
    const START_TIME = NOW.diff(moment('2021-11-04 04:00:00').utc());
    const END_TIME = NOW.diff(moment('2021-11-07 03:59:59').utc());

    if (START_TIME < 0 || END_TIME > 0) return false;

    return true;
  }

  static getLocalStorage() {
    try {
      if (TypeCheck.isValidObject(window)) {
        return window.localStorage;
      }
    } catch (e) {
      return null;
    }

    return null;
  }

  /**
   * staging 환경 확인
   * @returns
   */
  static isDevEnv() {
    return process.env.NEXT_PUBLIC_BASE_URL?.includes('staging');
  }

  /**
   * 성인 메뉴 활성화 / 비활성화 처리
   */
  static setNormalMode(value: string) {
    Cookies.set('snm', value);
  }

  /* -------------------------------------------------------------------------- */
  /* ANCHOR: 사용자 로케일 정보 저장 */
  /* -------------------------------------------------------------------------- */
  static setLocationString(location: string) {
    this.getLocalStorage()?.setItem('userLocationString', location);
  }

  static getLocationString() {
    const userLocale =
      this.getLocalStorage()?.getItem('userLocationString') ?? null;

    if (userLocale) {
      return userLocale;
    }
    return this.US;
  }

  /* -------------------------------------------------------------------------- */
  /* ANCHOR: 사용자 로케일 정보 저장 */
  /* -------------------------------------------------------------------------- */
  static setLocation(location: string) {
    this.getLocalStorage()?.setItem(this.KEY_USER_LOCALE, location);
  }

  static getLocation() {
    const userLocale =
      this.getLocalStorage()?.getItem(this.KEY_USER_LOCALE) ?? null;

    if (userLocale) {
      return userLocale;
    }
    return this.US;
  }

  /* -------------------------------------------------------------------------- */
  /* ANCHOR: 백앤드 서버 정보 */
  /* -------------------------------------------------------------------------- */

  /**
   * 서버 버전 정보 저장
   */
  static setServerVersion(value: string) {
    localStorage.setItem('sVersion', value);
  }

  /**
   * 서버 버전 정보 불러오기
   */
  static getServerVersion() {
    const serverVersion = localStorage.getItem('sVersion');
    if (serverVersion) {
      return `build ${serverVersion}`;
    }
    return '';
  }

  /**
   * 211006 가입완료 레이어 readmore url set
   * @param value 리다이렉트 url
   */
  static setJoinRedirect(value: string) {
    Cookies.set('joinRedirect2', value);
  }

  /**
   * 211006 가입완료 레이어 체크 플래그 제거
   */
  static resetJoinRedirect() {
    Cookies.remove('joinRedirect2');
  }

  /**
   * 211006 가입완료 레이어 처리 플래그
   * @returns url string
   */
  static getJoinRedirectWithReset() {
    const result = Cookies.get('joinRedirect2');
    this.resetJoinRedirect();
    return result;
  }

  /**
   * 회원 가입 클릭 이벤트 확인
   * 210907 플래그 기반 수정 처리
   */
  static clickSignUpEvent() {
    this.setSignUpCheck();
  }

  /**
   * 회원 가입처리 일괄처리 신규 SNS (비활성화)
   * 210907 플래그 기반 수정 처리
   */
  static requestSignUpSNS() {
    if (this.getSingUpState()) {
      const value = { timestamp: new Date().getTime() };
      localStorage.setItem('signUp2', JSON.stringify(value));
    }
  }

  /**
   * 회원 가입처리 일괄처리 신규
   * 210907 플래그 기반 수정 처리
   */
  static requestSignUp(accessToken: string) {
    if (this.getSingUpState() && accessToken != null) {
      const value = { timestamp: new Date().getTime() };

      // 회원가입 완료 플래그 (테스트용)
      localStorage.setItem('signUp2', JSON.stringify(value));

      // 회원가입 플래그 제거
      this.resetSingUpCheck();
    }
  }

  /* -------------------------------------------------------------------------- */
  // ANCHOR: => 결제 완료후 이동 페이지 지정
  /* -------------------------------------------------------------------------- */

  /**
   * ANCHOR: payment 페이지 유입 이전 페이지 확인용
   */
  static setPrevUrl(path: string) {
    localStorage.setItem('prevUrl', path);
  }

  /**
   * ANCHOR: payment 페이지 유입 이전 페이지 불러오기
   * @returns 해당 페이지로 복원 (query string 무시)
   */
  static getPrevUrl() {
    const result = localStorage.getItem('prevUrl') ?? '/';
    localStorage.removeItem('prevUrl'); // 복원시 삭제
    return result;
  }

  /**
   * ANCHOR: redirect시 진입 페이지로 복원처리용
   */
  static setPageRecovery(path: string) {
    localStorage.setItem('recoveryPage', path);
  }

  /**
   * ANCHOR: redirect 전 페이지 불러오기
   * @returns 최종 진입 페이지로 복원 (query string 무시)
   */
  static getLatestPage() {
    const result = localStorage.getItem('recoveryPage') ?? '/';
    localStorage.removeItem('recoveryPage'); // 복원시 삭제
    return result;
  }

  /* -------------------------------------------------------------------------- */
  // ANCHOR: => Google 추적 코드 관리용 (개발용)
  /* -------------------------------------------------------------------------- */

  /* -------------------------------------------------------------------------- */
  // ANCHOR: => 성인확인 코드 (회원 가입 및 로그인시 사용됨)
  /* -------------------------------------------------------------------------- */

  /**
   * ANCHOR: 성인 플래그 체크
   * @param value 0 비대상 1 대상
   */
  static set18Over(value: number) {
    localStorage.setItem('checked18Over', `${value}`);
  }

  /**
   * ANCHOR: 회원 가입시 성인 플래그 가져오기
   */
  static get18Over(localStorage: Storage): number {
    // 0 비대상 1 대상
    let result = localStorage.getItem('checked18Over') ?? 0;

    const { code } = this.getPartnerData(localStorage);

    result = code === '' ? result : 0;
    return Number(result);
  }

  /**
   * ANCHOR: 회원 가입 체크 플래그 삭제
   */
  static resetSingUpCheck() {
    localStorage.removeItem('signUp');
  }

  /**
   * ANCHOR: 회원 가입 체크 플래그 활성화
   */
  static setSignUpCheck() {
    const localStorage: any = UserDefault.getLocalStorage();
    const value = { timestamp: new Date().getTime() };
    localStorage.setItem('signUp', JSON.stringify(value));
  }

  /**
   * ANCHOR: 회원 가입요청 여부 판단 플래그
   * @returns 회원 가입 요청여부 판단
   */
  static getSingUpState() {
    const localStorage: any = UserDefault.getLocalStorage();
    if (localStorage.getItem('signUp')) {
      // const value = { timestamp: new Date().getTime() };
      // localStorage.setItem('signUpTrue', JSON.stringify(value));
      return true;
    }

    // const value = { timestamp: new Date().getTime() };
    // localStorage.setItem('signUpFalse', JSON.stringify(value));
    return false;
  }

  /* -------------------------------------------------------------------------- */
  // ANCHOR: => 프리티켓(선물함)
  /* -------------------------------------------------------------------------- */

  /**
   * ANCHOR: 프리티켓(선물함) 최초 1회 노출 정책 수행 적용 페이지에서 Goods값 확인 후 수행처리
   * @return {boolean} 로컬스토리지 기준 없을 시 true
   */
  static freeTicketVisiblePolicy(): boolean {
    const localStorage: any = UserDefault.getLocalStorage();

    if (localStorage.getItem('freeTicketOneTime')) {
      return false;
    }
    return true;
  }

  /**
   * ANCHOR: 프리티켓 숨김
   */
  static freeTicketVisibleDisable() {
    localStorage.setItem('freeTicketOneTime', 'true');
  }

  /**
   * ANCHOR: 로그인 혹은 가입 후 이동처리
   */
  static setRedirectPolicy(link: string) {
    const expiredAt = new Date(new Date().getTime() + 10 * 60 * 1000);
    Cookies.set('freeTicketRedirect', link, { expires: expiredAt });
  }

  /**
   * ANCHOR: 프리티켓 이동 후 제거
   */
  static removeFreeTicket() {
    Cookies.remove('freeTicketRedirect');
  }

  /**
   *  ANCHOR: 가입 혹은 가입 완료 후 이동처리
   */
  static singInOrOutRedirectPolicy(): boolean {
    if (TypeCheck.isValidObject(window)) {
      if (Cookies.get('freeTicketRedirect') === undefined) {
        return false;
      }

      if (Cookies.get('freeTicketRedirect')) {
        this.removeFreeTicket();
        return true;
      }

      return false;
    }

    return false;
  }

  static setSignInOrOutRedirectPolicy() {
    Cookies.set('freeTicketRedirect', 'true');
  }

  /* -------------------------------------------------------------------------- */
  // ANCHOR: => 결제 처리 관련
  /* -------------------------------------------------------------------------- */

  /**
   * ANCHOR: 코인 정보 갱신을 위한 쿠키 삭제
   */
  static coinResetManual() {
    Cookies.remove('coinRefresh');
  }

  /**
   * ANCHOR: 엑심베이용 콜백 url 정의
   */
  static setRedirectUrl(url: string) {
    if (this.getLocalStorage()) {
      this.getLocalStorage()?.setItem('cbUrl', url);
    }
  }

  /**
   * ANCHOR: 엑심베이용 콜백 url 불러오기
   */
  static getRedirectUrl() {
    if (this.getLocalStorage()) {
      const value = this.getLocalStorage()?.getItem('cbUrl');
      return value;
    }
    return null;
  }

  /* -------------------------------------------------------------------------- */
  // ANCHOR: => 결제 정보 처리
  /* -------------------------------------------------------------------------- */

  /**
   * ANCHOR: 결제 정보 복원
   * 21.12.01 fix: 유효시간 5분으로 처리
   * @param request 결제복원 정보
   */
  static setUserPaymentInfo(request: any) {
    if (TypeCheck.isValidObject(window)) {
      // 유효기간 5붖
      const expiredAt = new Date(new Date().getTime() + 5 * 60 * 1000);
      Cookies.set('payInfo-310', JSON.stringify(request), {
        expires: expiredAt,
      });
    }
  }

  // ANCHOR: 사용자 소셜 로그인 체크
  static setCheckSocialLogin(provider?: string) {
    if (TypeCheck.isValidObject(window)) {
      if (provider) {
        Cookies.set('loginProvider', provider, {
          expires: this.MAXDAYS,
        });
      }
    }
  }

  // ANCHOR: 사용자 소셜 로그인 체크 해제
  static removeCheckSocialLogin() {
    if (TypeCheck.isValidObject(window)) {
      Cookies.remove('loginProvider');
    }
  }

  // ANCHOR: 사용자 로그인된 이메일 정보 불러오기
  static getCheckSocialLogin() {
    if (TypeCheck.isValidObject(UserDefault.getLocalStorage())) {
      return Cookies.get('loginProvider') ?? '';
    }
  }

  // ANCHOR: 사용자 로그인 이메일  저장
  static setUserId(id?: string) {
    if (TypeCheck.isValidObject(window)) {
      if (id) {
        // 소셜 체크 제거
        this.removeCheckSocialLogin();
        Cookies.set(this.USERINFO, id, {
          expires: this.MAXDAYS,
        });
      }
    }
  }

  // ANCHOR: 사용자 로그인된 이메일 정보 불러오기
  static getUserId() {
    if (TypeCheck.isValidObject(UserDefault.getLocalStorage())) {
      return Cookies.get(this.USERINFO) || '';
    }
  }

  // ANCHOR test id 체크용
  static isTestId() {
    if (TypeCheck.isValidObject(UserDefault.getLocalStorage())) {
      const id = Cookies.get(this.USERINFO) || '';
      if (id === 'test@toptoonplus.com') return true;

      if (id === 'coinauto@test.com') {
        return true;
      }

      if (id === 'coinauto1@test.com') {
        return true;
      }

      if (id === 'coinauto2@test.com') {
        return true;
      }
    } else {
      return false;
    }
  }

  // AD block check
  static setAdBlock(isBlock: boolean) {
    if (TypeCheck.isValidObject(UserDefault.getLocalStorage())) {
      const userAgreement = { adblock: isBlock };
      window.localStorage.setItem('adblock', JSON.stringify(userAgreement));
    }
  }

  static getAdBlock() {
    if (TypeCheck.isValidObject(UserDefault.getLocalStorage())) {
      return window.localStorage.getItem('adblock');
    }
    return false;
  }

  /* -------------------------------------------------------------------------- */
  // ANCHOR: => 쿠키 동의 정보창
  /* -------------------------------------------------------------------------- */

  // ANCHOR: 쿠키 사용정책 동의
  static setAgreeCookiePolicy(isAgree: boolean) {
    if (TypeCheck.isValidObject(UserDefault.getLocalStorage())) {
      const userAgreement = { agree: isAgree };
      window.localStorage.setItem('agreeCookie', JSON.stringify(userAgreement));
    }
  }

  // ANCHOR: 쿠키 사용 사용자 동의 정보 가져오기
  static getAgreeCookiePolicy() {
    if (TypeCheck.isValidObject(UserDefault.getLocalStorage())) {
      return window.localStorage.getItem('agreeCookie');
    }
    return false;
  }

  // ANCHOR: user Device 값 (난수)
  static setUdid() {
    if (TypeCheck.isValidObject(window)) {
      const agent = uuidv4();
      window.localStorage.setItem('udid', agent);
    }
  }

  static getUdid(localStorage: Storage) {
    const result: string | null = localStorage.getItem('udid');
    if (result && TypeCheck.isValidString(result)) {
      return result?.toLowerCase();
    }
    UserDefault.setUdid();
    return localStorage.getItem('udid')?.toLowerCase();
  }

  // ANCHOR: user 쿠키 사용 정책 동의
  static setCookieUsedAgree() {
    if (TypeCheck.isValidObject(window)) {
      const agent = uuidv4();
      window.localStorage.setItem('cookies_agree', agent);
    }
  }

  static isCookieUsedAgree(): boolean {
    const result: string | null = localStorage.getItem('cookies_agree');
    if (result) {
      return true;
    } else {
      return false;
    }
  }

  // ANCHOR: 에피소드의 홈 레이어 쿠키 가져오기
  static getEpisodeAddHomeLayerCheck() {
    return Cookies.get(this.EPISODE_ADD_HOME_LAYER_CHECK) !== undefined;
  }

  // ANCHOR: 에피소드의 홈 레이어 쿠키값 저장
  static setEpisodeAddHomeLayerSet() {
    return Cookies.set(this.EPISODE_ADD_HOME_LAYER_CHECK, '1', {
      expires: 1,
    });
  }

  /**
   * Partner Code 저장 key: p_code / p_code17
   * @param key
   * @param value
   */
  static setPartnerId(key: string, value: any) {
    if (value !== undefined && value.length > 0) {
      Cookies.remove(this.PARTNER_17_CODE);
      Cookies.remove(this.PARTNER_CODE);
      Cookies.set(key, value, { expires: 1 });
    }
  }

  /**
   * 강제 성인 비노출 코드 set
   */
  static setPartnerCodeForceDisableMature() {
    const inFifteenMinutes = new Date(
      new Date().getTime() + 1 * 60 * 60 * 1000,
    );
    Cookies.set(this.PARTNER_CODE_FORCE_DISABLE_MATURE, '1', {
      expires: inFifteenMinutes,
    });
  }

  /**
   * 강제 성인 비노출 코드가 있는지 반환
   * @returns
   */
  static isForceDisableMature() {
    return Cookies.get(this.PARTNER_CODE_FORCE_DISABLE_MATURE) !== undefined;
  }

  /**
   * ANCHOR: 파트너코드 데이터 획득
   * @is17: 17금(구글) 코드인지에 대한 boolean
   */
  static getPartnerData(localStorage: Storage) {
    let code: string | undefined = '';
    let is17 = false;
    if (Cookies.get(this.PARTNER_17_CODE) !== undefined) {
      code = Cookies.get(this.PARTNER_17_CODE);
      is17 = true;
    }

    if (Cookies.get(this.PARTNER_CODE) !== undefined) {
      is17 = false;
      code = Cookies.get(this.PARTNER_CODE);
    }

    return {
      code,
      is17,
    };
  }

  /**
   * 마지막으로 본 remake 작품 ID를 저장
   */
  static setRemakeOriginId(id: number) {
    const remakeItems = [
      {
        name: 'H메이트',
        originId: 100084,
        comicId: 100199,
      },
      {
        name: '렛 미 드라이브',
        originId: 100172,
        comicId: 100203,
      },
      {
        name: '작은전쟁',
        originId: 100123,
        comicId: 100240,
      },
      {
        name: '약점',
        originId: 100227,
        comicId: 100301,
      },
      {
        name: 'SHE',
        originId: 100272,
        comicId: 100303,
      },
      {
        name: '동네누나',
        originId: 100132,
        comicId: 100635,
      },
      {
        name: '그남자의 자취방',
        originId: 100083,
        comicId: 100645,
      },
      {
        name: '비밀수업',
        originId: 100559,
        comicId: 100657,
      },
      {
        name: '하숙일기',
        originId: 100564,
        comicId: 100734,
      },
      {
        name: '멋진 신세계',
        originId: 100040,
        comicId: 100095,
      },
      {
        name: '새엄마의 친구들',
        originId: 100560,
        comicId: 100743,
      },
      {
        name: '피트니스',
        originId: 100548,
        comicId: 100826,
      },
      {
        name: '건물주 누나',
        originId: 100806,
        comicId: 100863,
      },
    ];

    const idx = _.findIndex(remakeItems, { comicId: id });

    if (idx >= 0) {
      // 24시간 기준으로 저장함.
      const inFifteenMinutes = new Date(new Date().getTime() + 60 * 60 * 1000);
      Cookies.set(this.REMATE_ORIGIN, `${remakeItems[idx].originId}`, {
        expires: inFifteenMinutes,
      });
    }
  }

  /**
   * remake 작품을 본 정보를 가져옴
   */
  static getRemakeOriginId() {
    if (Cookies.get(this.REMATE_ORIGIN) === undefined) {
      return 0;
    }
    return Number(Cookies.get(this.REMATE_ORIGIN));
  }

  /**
   // ANCHOR 사전 성인 인증 받은 상테인지 체크 (17금 파트너 코드가 존재할 경우 false 반환
   * @returns 
   */
  static isAlreadyMature() {
    if (
      Cookies.get(this.PARTNER_17_CODE) !== undefined ||
      Cookies.get(this.PARTNER_CODE) !== undefined
    )
      return false;

    return Cookies.get(this.ALREADY_MATURE) !== undefined;
  }

  /**
   // ANCHOR 사전 성인 인증 key 설정 (17금 파트너 코드가 존재할 경우 셋팅 안댐)
   * @param token 
   */
  static setTemporaryToken(token: string) {
    if (
      Cookies.get(this.PARTNER_17_CODE) !== undefined ||
      Cookies.get(this.PARTNER_CODE) !== undefined
    )
      return;

    // 쿠키 생존 시간 24일
    Cookies.set(this.TEMPARARY_TOKEN, token, { expires: 1 });
    // 쿠키 생존 시간 24일
    Cookies.set(this.ALREADY_MATURE, '1', { expires: 1 });
  }

  static getTemporaryToken(): string {
    if (Cookies.get(this.TEMPARARY_TOKEN) === undefined) return '';

    return Cookies.get(this.TEMPARARY_TOKEN) || '';
  }

  static getAppSnsLogingQueryString() {
    if (!this.isAlreadyMature()) {
      return '';
    }

    const tempToken = this.getTemporaryToken();
    const isAlreadyMature = Cookies.get(this.ALREADY_MATURE);

    return `?isAlreadyMature=${isAlreadyMature}&tempToken=${tempToken}`;
  }

  /**
   // ANCHOR 사전 성인 인증관련 키 삭제
   */
  static removeTemporyToken() {
    Cookies.remove(this.ALREADY_MATURE);
    Cookies.remove(this.TEMPARARY_TOKEN);
  }

  /**
   * ANCHOR 로그인 카운트 수집용 쿠키
   * 쿠키가 없을 경우 쿠키를 생성하고 api를 보냄
   * accessToken이 있을때만 동작 (로그인 상태에서만)
   */
  static isLoginCountCheck = (): boolean => {
    if (Cookies.get(this.LOGIN_COUNT_CHECK) !== undefined) {
      return false;
    }
    // 4시간 기준으로 호출 하도록 함.
    const inFifteenMinutes = new Date(
      new Date().getTime() + 4 * 60 * 60 * 1000,
    );

    Cookies.set(this.LOGIN_COUNT_CHECK, 'set', { expires: inFifteenMinutes });
    return true;
  };

  /**
   * 로그인 시점에 해당 쿠키 삭제
   */
  static removeLoginCountCookie = () => {
    if (Cookies.get(this.LOGIN_COUNT_CHECK) !== undefined) {
      Cookies.remove(this.LOGIN_COUNT_CHECK);
    }
  };

  /* -------------------------------------------------------------------------- */
  // ANCHOR: 5시간 기준 쿠키 생성
  /* -------------------------------------------------------------------------- */

  static set5HourCheck(value: boolean) {
    if (value) {
      Cookies.set(this.FIVE_DAY_CHECK, '5d', { expires: 5 });
    } else {
      Cookies.remove(this.FIVE_DAY_CHECK);
    }
  }

  static get5HourCheck() {
    return Cookies.get(this.FIVE_DAY_CHECK) ?? null;
  }

  /* -------------------------------------------------------------------------- */
  // ANCHOR: user sms 인증 쿠키 생성 (쿠키가 존재할 경우 layer를 띄우지 않음)
  /* -------------------------------------------------------------------------- */
  static isExistUserSmsData() {
    return Cookies.get(this.USER_SMS_AUTH) !== undefined;
  }

  static setUserSmsData() {
    if (this.isExistUserSmsData()) {
      Cookies.remove(this.USER_SMS_AUTH);
    }

    // 24시간 기준으로 호출 하도록 함.
    const inFifteenMinutes = new Date(
      new Date().getTime() + 24 * 60 * 60 * 1000,
    );

    Cookies.set(this.USER_SMS_AUTH, 'set', { expires: inFifteenMinutes });
  }

  /* -------------------------------------------------------------------------- */
  // ANCHOR: App 구분용 localstorage 생성
  /* -------------------------------------------------------------------------- */
  static setAppInfo(packageName: string, fcmToken: string, version: string) {
    if (packageName && version) {
      this.getLocalStorage()?.setItem(this.APP_PACKAGE_NAME, packageName);
      this.getLocalStorage()?.setItem(this.APP_VERSION, version);
    }

    if (fcmToken !== '')
      this.getLocalStorage()?.setItem(this.APP_FCM_TOKEN, fcmToken);
  }

  static getPackageName(localStorage: Storage): string {
    return localStorage.getItem(this.APP_PACKAGE_NAME) ?? 'web';
  }

  static getFcmToken(): string {
    return this.getLocalStorage()?.getItem(this.APP_FCM_TOKEN) ?? '';
  }

  static getAppVersion(): string {
    return this.getLocalStorage()?.getItem(this.APP_VERSION) ?? '';
  }

  static isAndroid(): boolean {
    const androidPackageNames = [
      'com.topco.toptoonglobal.global_toptoonplus_app',
    ];

    const pName: string | null | undefined = this.getLocalStorage()?.getItem(
      this.APP_PACKAGE_NAME,
    );
    if (pName && TypeCheck.isValidObject(pName)) {
      if (pName.length === 0) return false;
    }

    return androidPackageNames.includes(pName!);
  }

  static isIos(): boolean {
    const iosPackageNames = ['com.toptoonplus.global.ios'];

    const pName: string | null | undefined = this.getLocalStorage()?.getItem(
      this.APP_PACKAGE_NAME,
    );

    if (pName && TypeCheck.isValidObject(pName)) {
      if (pName.length === 0) return false;
    }

    return iosPackageNames.includes(pName!);
  }

  /**
   * app front 인지 여부 판단
   * @returns
   */
  static isUsedAppDomain(): boolean {
    if (TypeCheck.isValidObject(window)) {
      return window.location.href.startsWith('app.toptoonplus.com');
    }
    return false;
  }

  /**
   * 로그인 시 저장된 현재 page url
   * @returns
   */
  static getAppCurrentLocation(): string {
    if (Cookies.get(this.APP_CURRNET_LOCATION) !== undefined) {
      const result = Cookies.get(this.APP_CURRNET_LOCATION);
      Cookies.remove(this.APP_CURRNET_LOCATION);
      return result ?? '';
    }
    return '';
  }

  static setAppCurrentLocation() {
    if (window === undefined) return;

    const path = `${window.location.pathname}${window.location.search}`;
    const inFifteenMinutes = new Date(new Date().getTime() + 10 * 60 * 1000);
    Cookies.set(this.APP_CURRNET_LOCATION, path, { expires: inFifteenMinutes });
  }

  static storageLayerCheck = {
    setter: (key: string) => {
      const localStorage = this.getLocalStorage() ?? null;
      if (localStorage === null) return;
      const data = this.getLocalStorage()?.getItem(key);
      if (data !== null) return;

      localStorage.setItem(key, JSON.stringify(true));
    },
    isChecked: (key: string) => {
      const data = this.getLocalStorage()?.getItem(key);
      if (data) {
        return true;
      } else {
        return false;
      }
    },
  };

  // header
  static HeaderUserId = {
    setter: (localStorage: Storage, userId: string) => {
      localStorage.setItem('_user_id', userId);
    },
    getter: (localStorage: Storage) => {
      return localStorage.getItem('_user_id') ?? '';
    },
  };

  /**
   * page history 저장
   */
  static PageHistory = {
    setter: (path: string) => {
      const localStorage = this.getLocalStorage() ?? null;
      if (localStorage === null) return;

      const data = localStorage.getItem('page_history') ?? null;

      if (!data) {
        const array = Array();
        array.push(path);
        localStorage.setItem('page_history', JSON.stringify(array));
      } else {
        const queue = JSON.parse(data);

        if (queue[queue.length - 1] === path) return;

        queue.push(path);
        localStorage.setItem('page_history', JSON.stringify(queue));
      }
    },
    getter: () => {
      const queue = this.getLocalStorage()?.getItem('page_history');
      if (queue) {
        return JSON.parse(queue);
      } else {
        return [];
      }
    },
    referer: () => {
      const queue = this.getLocalStorage()?.getItem('page_history');
      if (queue) {
        const array = JSON.parse(queue);
        if (array.length <= 1) return null;
        else return array[array.length - 2];
      } else {
        return null;
      }
    },
    clear: () => {
      this.getLocalStorage()?.removeItem('page_history');
    },
  };
}
